module.exports = __webpack_public_path__ + "img/logo-light.7a29062c.png";